import React from "react";

const PageAction = ({ children }) => {
  return (
    <div className="page-footer">
      <div className="container bg-white">
        <div className="page-container text-center p-2">{children}</div>
      </div>
    </div>
  );
};

export default PageAction;
